import Fetch from "@/utils/Fetch"
import objectToFormData from "@/utils/ObjectToFormData";

export default {
	namespaced: true,
	state() {
		return {
			managers: null,
		}
	},
	mutations: {
		setManagers(state,managers) {
			state.managers = managers
		},
	},
	actions: {
		async createManager({commit, dispatch}, data) {
			commit('startLoading', 'createManager', {root: true});

			const body = objectToFormData(data);
			const response = await Fetch(`category-managers/`, {method: 'POST', body});

			if (response.success) {
				dispatch('requestManagers', {limit: 10})
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'createManager', {root: true})

			return {
				...response
			}
		},

		async requestManagers({commit, dispatch}, filter) {
			commit('startLoading', 'requestManagers', {root: true})

			const searchUrl = new URL('/', 'http://nahodka.localhost/')

			Object.entries(filter).forEach(([key, value]) => {
				if(value) {
					searchUrl.searchParams.append(key, String(value))
				}
			})

			const response = await Fetch(`category-managers/${searchUrl.search}`, {
				method: 'GET',
			})

			if (response.success) {
				commit('setManagers', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestManagers', {root: true})

			return {
				...response.data
			}
		},

		async requestCategoryAdmins({commit, dispatch}) {
			commit('startLoading', 'requestCategoryAdmins', {root: true})

			const response = await Fetch(`category-managers/my-category-admins/`, {
				method: 'GET',
			})

			if (response.success) {
				// commit('setManagers', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestCategoryAdmins', {root: true})

			return {
				...response
			}
		},

	},

	getters: {
		getManagers: state => state.managers,
	}
}

